import React, { useEffect } from 'react';
import { Grid2, MenuItem } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';
import { paymentTypes } from '../../Configurations/ExpenseEntryConfig';

const ExpensePaymentType = (props) => {
    const { index, expense, isPosted, isViewOnly, newSelection } = props;
    const { control, errors, setValue } = useFormContext();
    useEffect(() => {
        if (expense.vendorDefaultPaymentType) {
            setValue(
                `expenseEntries[${index}].paymentType`,
                expense.vendorDefaultPaymentType || ''
            );
        }
    }, []);

    return (
        <Grid2 item size={4}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].paymentType`}
                defaultValue={!expense.paymentType ? '' : expense.paymentType}
                rules={{
                    required: 'Payment type is required',
                }}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        id="payment-type"
                        select
                        onChange={(e) => {
                            setValue(`expenseEntries[${index}].paymentType`, e.target.value);
                            newSelection(e);
                            onChange(e);
                        }}
                        value={!value ? '' : value}
                        label="Payment type"
                        required
                        disabled={isViewOnly || isPosted}
                        error={Boolean(errors.expenseEntries?.[index]?.paymentType)}
                        helperText={errors.expenseEntries?.[index]?.paymentType?.message}
                    >
                        <MenuItem value="" disabled>
                            Select a payment type
                        </MenuItem>
                        {paymentTypes.map((option, i) => (
                            <MenuItem
                                key={option.value}
                                value={option.value}
                                id={`payment-type-menu-option-${i}`}
                            >
                                {option.type}
                            </MenuItem>
                        ))}
                    </ExpenseTextField>
                )}
            />
        </Grid2>
    );
};

export default ExpensePaymentType;
